<template>
    <div :id="barID" :option="option"></div>
</template>
<script>
export default {
    props: {
		  option: {
			type: Object,
			default: () => {},
		},
        barID: [String, Number], 
		isFz:[String, Number]
		},
    data() {
        return {
             chartsDom:''
        }
    },
      watch: {
			 option: {
			handler(newVal, oldVal) {
			  if (this.chartsDom ) {
			  if (newVal) {
				this.chartsDom.setOption(newVal);
			  } else {
				this.chartsDom.setOption(oldVal);
			  }
			  }else{
				  this.init()
			  }
			},
			},
	},
    created () {
    },
        methods: {
            init() {
                let chartsDom = this.$echarts.init(document.getElementById(this.barID));
                this.chartsDom = chartsDom
				this.chartsDom.setOption(this.option);
				window.addEventListener("resize", function() {
					chartsDom.resize();
				});
            },
    },
    beforeDestroy(){
			 window.removeEventListener("resize",function() {
					this.chartsDom.resize();
				});
		},
}
</script>
<style lang="scss" scoped>
#barID,#barID1,#barID2,#barID3,#barID4,#barID5,#barID6,#barID7,#barID8,#barID9{
    height: 390px;
    margin-top: 0px;
}
</style>